module.exports = __webpack_public_path__ + "img/table1.ee60a726.png";